var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "header-icon m-2",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-1 {\n            fill: #fff;\n            stroke-width: 0px;\n        }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.1,88v103.4H24.4V53.6l24.4-24.4h52.3c1.1-2.2,2.6-4.2,4.6-6h-58.1c-.8,0-1.6.3-2.1.9l-26.1,26.1c-.6.6-.9,1.3-.9,2.1v142.1c0,1.7,1.3,3,3,3h121.7c1.7,0,3-1.3,3-3v-107.7c-1.9.8-3.9,1.2-6,1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.5,55.3h-26.1c-1.2,0-2.3-.7-2.8-1.9-.5-1.1-.2-2.4.7-3.3l26.1-26.1c.9-.9,2.1-1.1,3.3-.7,1.1.5,1.9,1.6,1.9,2.8v26.1c0,1.7-1.3,3-3,3ZM28.6,49.3h15.9v-15.9l-15.9,15.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.8,85.9h-62.5c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h71.4c-3.3-1.7-6.3-3.8-8.9-6.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.2,109.7H41.2c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1h82c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.2,128H41.2c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1h82c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.9,92c-24.7,0-44.7-20.1-44.7-44.7S112.2,2.5,136.9,2.5s44.7,20.1,44.7,44.7-20.1,44.7-44.7,44.7ZM136.9,8.6c-21.4,0-38.7,17.4-38.7,38.7s17.4,38.7,38.7,38.7,38.7-17.4,38.7-38.7-17.4-38.7-38.7-38.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.6,69.3c-4.7,0-8.8-2.3-10.9-6.2-.8-1.5-.2-3.3,1.2-4.1,1.5-.8,3.3-.2,4.1,1.2,1.5,2.9,4.9,3.3,7.4,2.9,2.5-.5,5.6-2.2,6-5.5.5-4.3-2.3-6.1-7.3-8.9-4.6-2.6-10.3-5.8-10.2-12.9.1-4.9,3.2-9,7.9-10.6,4.7-1.6,9.7-.2,12.8,3.7,1,1.3.8,3.2-.5,4.2-1.3,1-3.2.8-4.2-.5-1.7-2.2-4.3-2.3-6.2-1.7-1.8.6-3.8,2.3-3.8,5.1,0,3.4,2.6,5.1,7.1,7.6,4.8,2.7,11.3,6.3,10.3,14.8-.6,5.4-4.9,9.6-10.9,10.7-1,.2-1.9.3-2.9.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.9,30.7c-1.7,0-3-1.3-3-3v-6.6c0-1.7,1.3-3,3-3s3,1.3,3,3v6.6c0,1.7-1.3,3-3,3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.9,76.5c-1.7,0-3-1.3-3-3v-7.3c0-1.7,1.3-3,3-3s3,1.3,3,3v7.3c0,1.7-1.3,3-3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidImg);
export default __webpack_public_path__ + "static/media/bid-img.3498be75f363c0078a96b86caa1e2c4c.svg";
export { ForwardRef as ReactComponent };